import './style.scss';
import MyComponent from './divider.js';

export default MyComponent;